import { BookingState } from ".";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: BookingState = {
  tab: 0,
  bookings: [],
  listStatus: "idle",
  bookingsFetchedAt: null,
  booking: null,
  loading: false,
  timeFormat: "24",
};

export const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTab: (state, action: PayloadAction<number>) => {
      state.tab = action.payload;
    },
    setBooking: (state, action: PayloadAction<any>) => {
      state.booking = action.payload;
    },
    addBooking: (state, action) => {
      state.bookings.unshift(action.payload);
    },
    updateBooking: (state, action) => {
      const booking = action.payload;
      state.booking = booking;
      /* A cancelled or edited booking: the list behind it is out of date. */
      state.bookingsFetchedAt = null;
      // state.bookings.every(({ _id }, i) => {
      //   if (booking._id === _id) {
      //     state.bookings[i] = booking;
      //     return false;
      //   }
      //   return true;
      // });
    },
    setBookings: (state, action) => {
      state.bookings = action.payload;
      state.listStatus = "ready";
      state.bookingsFetchedAt = Date.now();
    },
    setListStatus: (
      state,
      action: PayloadAction<"idle" | "loading" | "ready" | "failed">
    ) => {
      state.listStatus = action.payload;
    },
    invalidateBookings: (state) => {
      state.bookingsFetchedAt = null;
    },
    setTimeFormat: (state, action: PayloadAction<"12" | "24">) => {
      state.timeFormat = action.payload;
    },
  },
});

const bookingReducer = bookingSlice.reducer;

export const bookingActions = bookingSlice.actions;
export default bookingReducer;
